import { render, staticRenderFns } from "./PasswordIssueResult.vue?vue&type=template&id=664f0a92&"
import script from "./PasswordIssueResult.vue?vue&type=script&lang=ts&"
export * from "./PasswordIssueResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports